<template>
  <div class="outer-wrapper">
    <div v-for="catagory in resMenuData.filter(val=>val.ifShow)" :key="catagory.id+'cata'" class="catagory-wrapper">
    <div class="title">
      <p>
        <span class="title-text">{{catagory.text}}</span>
      </p>
    </div>
    <van-grid :column-num="3">
      <van-grid-item :icon="ele.icon" :text="ele.text" :info="ele.quantity===0?undefined:ele.quantity" 
      @click="link(ele.to)" v-for="ele in catagory.children.filter(val=>val.ifShow)" :key="ele.id+'ele'">
      <template slot="icon"><van-icon :name="ele.icon" :color="ele.iconColor" size="1.8rem"/></template>
      </van-grid-item>
      <!--<van-grid-item icon="diamond-o" text="待批准" info="99+" @click="link('/reportApprove')" />
      <van-grid-item icon="gift-o" text="待收取" info="99+" @click="link('/sampleManage')" />
      <van-grid-item icon="newspaper-o" text="待检测" info="99+" @click="link('')" />
      <van-grid-item icon="balance-o" text="待付费" dot @click="link('')" />-->
    </van-grid>
    </div>
  </div>
</template>
<script>
let authority = [];
let userToken = localStorage.getItem("current_user_token");
let authData = JSON.parse(localStorage.getItem("authData"));
if (authData) {
  authority = authData.barRights;
}

export default {
  name: "indexContent",
  data() {
    return {
      defaultMenuData: [
        {
          id: "0",
          text: "样品检测",
          ifShow: true,
          icon: "ios-flask",
          children: [
            { text: "接收任务", id: "0-1", to: "acceptableTask", ifShow: true ,quantity:0,icon:'peer-pay',iconColor:'#07c160'},
            { text: "我的任务", id: "0-2", to: "myTask", ifShow: true ,quantity:0,icon:'apps-o',iconColor:'#07c160'},
            { text: "原始记录", id: "0-3", to: "originRecord", ifShow: true ,quantity:0,icon:'notes-o',iconColor:'#07c160'},
            /*{ text: "录入数据", id: "0-2", to: "inspectionWork", ifShow: true }*/
          ]
        },
        {
          id: "1",
          text: "报告相关",
          ifShow: true,
          icon: "ios-paper",
          children: [
            /*{ text: "报告查询", id: "1-1", to: "wreportQuery", ifShow: true },
            { text: "报告编辑", id: "1-2", to: "reportEditS", ifShow: true },
            { text: "待审核", id: "1-3", to: "reportVerify", ifShow: true,quantity:0,icon:'eye-o',iconColor:'#1989fa' },
            { text: "待批准", id: "1-4", to: "reportApprove", ifShow: true,quantity:0,icon:'diamond-o',iconColor:'#1989fa'},
            { text: "报告打印", id: "1-5", to: "reportPrint", ifShow: true }*/
            { text: "我的报告", id: "1-6", to: "myReport", ifShow: true,icon:'newspaper-o',iconColor:'#1989fa'},
          ]
        },
        // {
        //   id: "2",
        //   text: "业务管理",
        //   ifShow: true,
        //   icon: "md-analytics",
        //   children: [
        //     /*{ text: "新建委托", id: "2-1", to: "orderWork", ifShow: true },
        //     { text: "委托管理", id: "2-2", to: "orderManage", ifShow: true },
        //     { text: "客户管理", id: "2-3", to: "customerManage", ifShow: true },
        //     { text: "产品管理", id: "2-4", to: "productManage", ifShow: true },*/
        //     //{ text: "待收取", id: "2-5", to: "sampleManage", ifShow: true,quantity:0,icon:'gift-o',iconColor:'#1a4a36'},
        //     { text: "收件管理", id: "2-6", to: "packageManage", ifShow: true,quantity:0,icon:'gift-o',iconColor:'#1a4a36'},
        //     /*{ text: "快递发货", id: "2-6", to: "deliveryManage", ifShow: true }*/
        //   ]
        // },
        {
          id: "3",
          text: "资料档案",
          ifShow: true,
          icon: "ios-stats",
          children: [
            { text: "标准查询", id: "3-1", to: "standard_l", ifShow: true,icon:'description',iconColor:'#832c62' },
            /*{
              text: "标准数据维护",
              id: "3-2",
              to: "standardManage",
              ifShow: true
            },*/
            { text: "失效案例查询", id: "3-3", to: "ra_l", ifShow: true,icon:'points',iconColor:'#832c62' },
            /*{
              text: "失效案例数据维护",
              id: "3-4",
              to: "raManage",
              ifShow: true
            },*/
            { text: "材料查询", id: "3-5", to: "mat_l", ifShow: true,icon:'cluster',iconColor:'#832c62' },
            /*{ text: "材料数据维护", id: "3-6", to: "matManage", ifShow: true }*/
          ]
        },
        // {
        //   id: "4",
        //   text: "销售支持",
        //   ifShow: true,
        //   icon: "ios-stats",
        //   children: [
        //     { text: "检测意向", id: "4-1", to: "intention/rpManage", ifShow: true,icon:'flower-o',iconColor:'#e32c12' },
        //     { text: "项目管理", id: "4-2", to: "intention/wcManage/n", ifShow: true,icon:'font-o',iconColor:'#e32c12' },
        //     { text: "项目进度", id: "4-3", to: "superProjectList", ifShow: true,icon:'underway-o',iconColor:'#e32c12' },
        //     /*{
        //       text: "标准数据维护",
        //       id: "3-2",
        //       to: "standardManage",
        //       ifShow: true
        //     },*/
        //     { text: "分包统计", id: "4-4", to: "supplierAnalysis", ifShow: true,icon:'peer-pay',iconColor:'#e32c12' },
        //     /*{
        //       text: "失效案例数据维护",
        //       id: "3-4",
        //       to: "raManage",
        //       ifShow: true
        //     },*/
        //     { text: "生产厂家", id: "4-5", to: "manufacturerData", ifShow: true,icon:'hotel-o',iconColor:'#e32c12' },
        //     /*{ text: "材料数据维护", id: "3-6", to: "matManage", ifShow: true }*/
        //   ]
        // },
        {
          id: "5",
          text: "实验室管理",
          ifShow: true,
          icon: "ios-people",
          children: [
            {
              text: "统计数据",
              id: "5-1",
              to: "dataPanel",
              ifShow: true,
              icon:'chart-trending-o',iconColor:'#160a23'
            },
            {
              text: "铁道工程",
              id: "5-2",
              to: "railway",
              ifShow: true,
              icon:'birthday-cake-o',iconColor:'#160a23'
            },
            /*{
              text: "人员权限管理",
              id: "4-2",
              to: "staffManage",
              ifShow: true
            },
            {
              text: "设备管理",
              id: "4-3",
              to: "equipmentManage",
              ifShow: true
            },
            {
              text: "检测数据记录管理",
              id: "4-4",
              to: "recordManage",
              ifShow: true
            }*/
          ]
        },
        /*{
          id: "5",
          text: "综合服务",
          ifShow: true,
          icon: "ios-cafe",
          children: [
            { text: "寄快递", id: "5-1", to: "personalDelivery", ifShow: true }
          ]
        },
        {
          id: "6",
          text: "财务相关",
          ifShow: true,
          icon: "logo-yen",
          children: [
            { text: "收款登记", id: "6-1", to: "cashCheck", ifShow: true },
            { text: "收款记录", id: "6-2", to: "cashRecord", ifShow: true }
          ]
        }*/
      ],
      resMenuData:[]
    };
  },
  computed:{
    menuData: function() {
      let newData = JSON.parse(JSON.stringify(this.defaultMenuData));
      if (authority.indexOf("super_all") !== -1) {
        return newData;
      } else if (authority.length === 0) {
        return [];
      } else {
        for (let i = 0; i < this.defaultMenuData.length; i++) {
          for (let j = 0; j < this.defaultMenuData[i].children.length; j++) {
            if (
              authority.indexOf(this.defaultMenuData[i].children[j].to) === -1
            ) {
              newData[i].children[j].ifShow = false;
            } else {
              newData[i].children[j].ifShow = true;
            }
          }
          if (
            newData[i].children.every(ele => {
              return !ele.ifShow;
            })
          ) {
            newData[i].ifShow = false;
          } else {
            newData[i].ifShow = true;
          }
        }
        return newData;
      }
    }
  },
  methods: {
    link: function(value) {
      location.href = '/'+value;
    },
    getTaskAuantity(){
      this.$axios
        .post(this.$url + "/task_info", {
          userToken: userToken,
          askData: 'taskQuantity',
          menuData:JSON.stringify(this.menuData)
        })
        .then(response => {
          if(response.data.stat=='ok'){
            this.resMenuData = response.data.res_record;
          }else{
            this.$toast(response.data.error_info);          
          }
        })
          .catch(error => {
            this.$toast("网络无法连接或" + error);
          });
    }
  },
  created(){
    this.getTaskAuantity();

  }
};
</script>
<style scoped>
.outer-wrapper {
  min-height: 22rem;
}


.title {
  padding: 0.2rem 0.3rem;
  margin: 1rem 1rem 0;
  border-bottom: 1px solid #999;
  color: #666;
  font-size: 0.5rem;
  font-family: 'HeiTi';
}

.title .icon {
  position: relative;
  top: 0.2rem;
}
.title-text {
  padding-left: 0.6rem;
}
</style>